import React from 'react';
import Head from "next/head";
import Index from "../views/Privacy";

const PrivacyPolicy = () => {
  return (
    <div>
      <Head>
        <title>North West Region Virtual Care Clinic</title>
        <meta
          name="North West Region Virtual Care Clinic - Privacy Policy"
          content="The Noth West Region Virtual Care Clinic is supported and staffed by Nurse Practitioners in Ontario"
        />
      </Head>
      <Index />
    </div>
  );
};

export default PrivacyPolicy;